/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MapsService } from '../../maps.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { MapSettingsComponent } from 'app/components/map-settings/map-settings.component';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';

@Component({
  selector: 'app-map-header',
  templateUrl: './map-header.component.html',
  styleUrls: ['./map-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapHeaderComponent implements OnInit {

  currentTab: string = 'EMPLOYEE';
  settings: any = {
    'overlay_routes': false,
    'overlay_territories': false
  };
  territories: any[] = [];

  constructor(
    private _mapService: MapsService,
    private _zuperDrawerService: ZuperDrawerService,
    private _localStorageService: LocalStorageService,
    private _dataCollectorService: DataCollectorService,
    private _zuperDialogService: ZuperDialogService
  ) { }

  openLegend(): any {
    this._zuperDrawerService.getComponent('legendDrawer').open();
    this._mapService.legendDrawerToggler.next('open');
  }

  selectTab(module): void {
    this._mapService.prevTab = this.currentTab;
    this.currentTab = module;
    this._mapService.tab.next(this.currentTab);
  }

  openSettings(): void {
    const data = this._localStorageService.getLocalStorage('map_settings');
    if(data){
      this.settings = data;
    }
    this._zuperDialogService.openCustom(MapSettingsComponent,{
      data: {
        'settings': this.settings
      }
    }).afterClosed().subscribe((res: any) => {
      if(res){
        this.settings = res;
        this._localStorageService.setLocalStorage('map_settings', this.settings);
        if(this.settings['overlay_territories']){
          this.getServiceTerritory();
        }else {
          this._mapService.serviceTerritoryLocationData.next([]);
        }
        if(this.settings['overlay_routes']){
          this._mapService.routeLocationData.next('ADD_ROUTE');
        }else{
          this._mapService.routeLocationData.next('REMOVE_ROUTE');
        }
        this._mapService.routeLocationData.next('UPDATE_MAP_SETTINGS');
      }
    });
  }

  getServiceTerritory(): void {
    const filter = {
      count: 100,
      page: 1
    };
    this._dataCollectorService.getData(this._mapService.mapsAPi.getServiceTerritory, filter)
      .subscribe((res: any) => {
        this.territories = res?.data;
        this._mapService.serviceTerritoryLocationData.next(this.territories);
      });
  }

  ngOnInit(): void {
    const data = this._localStorageService.getLocalStorage('map_settings');
    if(data){
      this.settings = data;
    }
    if(this.settings['overlay_territories']){
      this.getServiceTerritory();
    }
  }

}
